<template lang="pug">
.pa-3
  v-dialog(v-model='isModalConfirmacion'  width='450' min-height="500" @click:outside="limpiarValoresConfirmacion")
    v-card.pa-5
      h2.text-center.font-weight-700.my-2 ¿Deseas continuar con la generación de  tickets?
      .my-2.ma-4
        .d-flex.ai-center.jc-center.py-2
          v-icon(size="150" color="background")  control_point_duplicate
        .d-flex.my-4(v-if="isUploadModal")
          v-file-input(
            v-model='filesTickets'
            color='primary'
            label='Adjuntar sustento para las series (boleta/factura)'
            solo
            :multiple='false'
            dense
            placeholder='Selecciona un archivo'
            persistent-hint
            hint="Es importante adjuntar el sustento por que hay series que se encuentran en garantia."
          )
            template(v-slot:selection='{ index, text }')
              v-chip(v-if='index < 2' color='primary' dark='' label='' small='')
                | {{ text }}
              span.text-overline.grey--text.text--darken-3.mx-2(v-else-if='index === 2')
                | +{{ files.length - 2 }} File(s)
        span.text-muted.font-size-11 Este proceso generará {{equiposLista.length}} tickets configurados previamente, Verificar.
      v-card-actions
        v-btn(color='success'  block :small="!isMovil" @click="fetchProcesoGenerarTickets")
          | Generar tickets
  v-dialog(v-model='isModalErroresEncontrados'  width='600' min-height="500" @click:outside="clsoeErroresEncontrados()")
    v-card.pa-4
      .px-4.py-3
        h1.text-center.font-weight-700 Validaciones
      v-card.overflow-y-auto.elevation-0(max-height="calc(100vh - 380px)")
        .pa-1.font-size-12.font-weight-700(v-for="(e, index) in erroresValidacion" :key="index") • {{e}}
      v-card-actions.mt-4
        v-btn(color='primary'  block :small="!isMovil" @click="clsoeErroresEncontrados()")
          | Cerrar
  v-card.mx-auto.elevation-1
    .d-flex(:class="{'fd-column' : isMovil}")
      .flex-1
        v-card-title.pa-3.pl-4
          span.font-weight-700(:class="{'font-size-17' : isMovil}") Generar tickets por plantilla
        v-card-subtitle.pb-3.font-size-13 Sube tu plantilla y edita los valores antes de generar
      v-divider(v-if="isMovil")
      v-card.d-flex.elevation-0.ai-center(:class="{'ma-2' : !isMovil}" v-if="equiposLista.length")
        //- v-btn.ma-1( color="error" small  @click="volverASeleccionar()")
        //-   v-icon arrow_back
        //-   span Volver adjuntar
        //- v-btn( color="error" :small="!isMovil" :block="isMovil"  @click="validarDatosExcel()")
        //-   v-icon arrow_back
        //-   span Validar datos antes de guardar
    v-divider
    v-card.elevation-0(:height="isMovil ? 'calc(100vh - 192px)' : 'calc(100vh - 144px)'" v-if="equiposLista.length")
      v-data-table.elevation-0(
        :height="isMovil ? 'calc(100vh - 295px)' : 'calc(100vh - 194px)'"
        fixed-header
        :headers='headers'
        :items='equiposLista'
        dense
        hide-default-footer
        disable-pagination
      )
        //- template(v-slot:item.files='{ item }')
        //-   v-file-input(
        //-     v-model='files'
        //-     color='primary'
        //-     counter=''
        //-     label='Adjuntar sustento'
        //-     solo
        //-     :multiple='false'
        //-     dense
        //-     hide-details
        //-     placeholder='Selecciona un archivo'
        //-     :show-size='1000'
        //-   )
        //-     template(v-slot:selection='{ index, text }')
        //-       v-chip(v-if='index < 2' color='primary' dark='' label='' small='')
        //-         | {{ text }}
        //-       span.text-overline.grey--text.text--darken-3.mx-2(v-else-if='index === 2')
        //-         | +{{ files.length - 2 }} File(s)

          //- v-file-input.ma-1(small-chips='' :multiple='false' :color="item.sigueEnGarantia ? 'primary' : 'ligth'" dense solo label="" hide-details)
          //- v-btn( :color="item.sigueEnGarantia ? 'primary' : 'ligth'" x-small :block="isMovil" )
          //-   | Adjuntar
        template(v-slot:item.status='{ item }')
          v-icon(v-if="item.status" color="success") check_circle
          v-icon(v-else color="warning") pending_actions
        template(v-slot:item.usuario='{ item }')
          span.font-weight-700(:class="{'error--text' : !item.usuario}") {{item.usuario || 'Es requerido'}}
        template(v-slot:item.serie='{ item }')
          span.font-weight-700(:class="{'error--text' : !item.serie}") {{item.serie || 'Es requerido'}}
        template(v-slot:item.tipo='{ item }')
          span.font-weight-700(:class="{'error--text' : !item.tipo}") {{item.tipo || 'Es requerido'}}
        template(v-slot:item.numeroFactura='{ item }')
          span.font-weight-700 {{ item.numeroFactura }}
        template(v-slot:item.sigueEnGarantia='{ item }')
          v-checkbox.ma-0(hide-details v-model='item.sigueEnGarantia'  color="primary" disabled)
        template(v-slot:item.comproAqui='{ item }')
          v-checkbox.ma-0(hide-details v-model='item.comproAqui'  color="primary" disabled)
      v-divider
      .pa-3.d-flex.ai-center.flex-wrap
        small.text-muted.font-size-11(v-if="!isMovil") Mostrando {{equiposLista.length}} registros
        v-spacer
        v-btn( color="error" :small="!isMovil" :block="isMovil"  @click="volverASeleccionar()" :class="{'mx-2' : !isMovil}" :disabled="isLoadingProceso")
          v-icon arrow_back
          span Volver adjuntar
        v-btn( color="success" :small="!isMovil" :block="isMovil" :disabled="!equiposLista.length || isLoadingProceso" :class="{'mt-2' : isMovil}" @click="openModalValidarDatos()")
          | Iniciar proceso
    v-card.d-flex.jc-center.ai-center.elevation-0.flex-wrap(v-else, height="calc(100vh - 144px)" id="fileSelect")
      input.display-none#fileElement( v-if="renderInputFile" type='file' @change="decodedExcel" accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      v-card.ma-4.d-flex.ai-center.jc-center.fd-column.pa-8(:width="isMovil ? '100%' :  300" :height="isMovil ? 220 : 300" color="primary white--text" @click="adjuntarFileExcel" hover)
        v-icon.animated.fadeInUp(size="60") cloud_upload
        h1.font-weight-700.animated.fadeInLeft Adjuntar
      v-card.ma-4.d-flex.ai-center.jc-center.fd-column.pa-8(:width="isMovil ? '100%' :  300" :height="isMovil ? 220 : 300" color="secondary primary--text" @click="fetchDescargarPlantilla" hover)
        v-icon.animated.fadeInDown(size="60" color="primary") cloud_download
        h1.font-weight-700.animated.fadeInLeft Plantilla

</template>
<script>
import adjuntarArchivos from '../components/c_adjuntar_archivos'
import { notify, apiGetExcel, apiPost, apiUploadWithParams } from '../util/general'
import Excel from 'exceljs'
export default {
  components: {
    'adjuntar-archivos' : adjuntarArchivos
  },
  data () {
    return {
      equiposLista: [],
      headers: [
        {text: 'Usuario', align: 'start', value: 'usuario'},
        {text: 'Tipo de ticket', align: 'start', value: 'tipo'},
        {text: 'Serie', align: 'start', value: 'serie'},
        // {text: 'Marca', align: 'start', value: 'marca'},
        // {text: 'Modelo', align: 'start', value: 'modelo'},
        // {text: 'tipo', align: 'start', value: 'tipo'},
        // {text: 'tipoInforme', align: 'start', value: 'tipoInforme'},
        // {text: 'comentarioFalla', align: 'start', value: 'comentarioFalla'},
        // {text: 'comentarioGeneral', align: 'start', value: 'comentarioGeneral'},
        {text: '¿Compro aqui?', align: 'center', value: 'comproAqui'},
        {text: '¿En garantia?', align: 'center', value: 'sigueEnGarantia'},
        {text: 'Factura', align: 'start', value: 'numeroFactura'},
        {text: 'Status', align: 'start', value: 'status'}
        // {text: 'Sustento', align: 'start', value: 'files'}
        // {text: 'Tipo Equipo', align: 'start', value: 'tipoEquipo'},
        // {text: 'Falla', align: 'start', value: 'falla'},
        // {text: 'Acciones', align: 'center', value: 'actions'}
        // {text: 'departamente', align: 'start', value: 'departamente'},
        // {text: 'provincia', align: 'start', value: 'provincia'},
        // {text: 'distrito', align: 'start', value: 'distrito'},
        // {text: 'ubigeo', align: 'start', value: 'ubigeo'}
      ],
      ticket : {
        tipo             : '',
        tipoInforme      : 1,
        serie            : '',
        falla            : {},
        comentarioFalla  : '',
        comentarioGeneral: '',
        files            : [],
        sigueEnGarantia  : false,
        numeroFactura    : '',
        tipoEquipo       : {},
        marca            : '',
        modelo           : '',
        comproAqui       : false,
        departamente     : '',
        provincia        : '',
        distrito         : '',
        ubigeo           : '',
        usuario          : '',
        status           : 0,
        numero           : ''
      },
      isModalConfirmacion      : false,
      isModalErroresEncontrados: false,
      isUploadModal            : false,
      erroresValidacion        : [],
      filesTickets             : [],
      isLoadingProceso : false,
      renderInputFile : true
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    fetchProcesoGenerarTickets () {
      var vm = this
      if (!vm.filesTickets.length) {
        notify(vm, 'error', 'Error', 'Es necesario adjuntar el sustento pueder ser la boleta o la factura.')
        return
      }

      // vm.$store.dispatch('transaccion', { isProceso : true, message : `Generando ticket` })
      vm.isLoadingProceso = true
      vm.isModalConfirmacion = false
      vm.uploadFile(vm.filesTickets[0], (err, response) => {
        if (err) {
          notify(vm, 'error', 'Error', err)
        } else {
          vm.guardarTicketRecursivo(0, response, err => {
            if (err) {
              notify(vm, 'error', 'Error', err.message)
              vm.$store.dispatch('transaccion', { isProceso : false })
              vm.isLoadingProceso = false
              return
            }

            notify(vm, 'success', 'Exito', 'Los tickets se generarón correctamente')
            vm.limpiarValoresConfirmacion()
            vm.notificarTicketsGenerados(err => {
              if (err) notify(vm, 'error', 'Error', err)
              vm.volverASeleccionar()
            })
            vm.isLoadingProceso = false
            // vm.$store.dispatch('transaccion', { isProceso : false })
          })
        }
      })
    },
    notificarTicketsGenerados (callback) {
      var vm = this
      var obj = { grupos : vm.equiposLista }
      apiPost(vm, '/ticket/plantilla/notificar', obj, function (data) {
        callback(null, data)
      }, function (error) {
        callback(error)
      })
    },
    limpiarValoresConfirmacion () {
      var vm = this
      vm.filesTickets = []
      vm.isUploadModal = false
      vm.isModalConfirmacion = false
    },
    volverASeleccionar () {
      var vm = this
      vm.equiposLista = []
    },
    async decodedExcel (event) {
      var vm               = this
      console.log('event', event)
      var data             = event.target;
      var consolidado      = []
      vm.erroresValidacion = []
      vm.equiposLista      = []
      if (data.files.length) {
        try {
          var workbook = await vm.getRowsFileExcel(data.files[0])
          workbook.eachSheet((sheet, id) => {
            sheet.eachRow((row, rowIndex) => {
              if (rowIndex > 1) {
                // console.log(row.values, rowIndex)
                if (!row.values[1]) vm.erroresValidacion.push(`[Fila ${rowIndex}]  El valor del campo usuario no puede estar vacio`)
                if (!row.values[2]) vm.erroresValidacion.push(`[Fila ${rowIndex}]  El valor el campo tipo de ticket no puede estar vacio`)
                if (!row.values[3]) vm.erroresValidacion.push(`[Fila ${rowIndex}]  La valor del campo compro aqui no puede estar vacio`)
                if (row.values[3] !== 'SI' && row.values[3] !== 'NO') vm.erroresValidacion.push(`[Fila ${rowIndex}]  El valor del campo compro aqui no es valido, use SI o NO`)
                if (row.values[4] !== 'SI' && row.values[4] !== 'NO') vm.erroresValidacion.push(`[Fila ${rowIndex}]  El valor del campo sigue en garantia no es valido, use SI o NO`)
                if (!row.values[5]) vm.erroresValidacion.push(`[Fila ${rowIndex}]  La valor del campo serie no puede estar vacio`)
                if (!row.values[6] && row.values[4] === 1) vm.erroresValidacion.push(`[Fila ${rowIndex}]  El valor del campo factura no puede estar vacio`)
                var newTicketObj = {...vm.ticket}
                newTicketObj.usuario         = row.values[1]
                newTicketObj.tipo            = row.values[2]
                newTicketObj.comproAqui      = row.values[3] === 'SI'
                newTicketObj.sigueEnGarantia = row.values[4] === 'SI'
                newTicketObj.serie           = row.values[5]
                newTicketObj.numeroFactura   = row.values[6]
                consolidado.push(newTicketObj)
              }
            })
          })
        } catch (error) {
          notify(vm, 'error', 'Error', error)
        } finally {
          if (!vm.erroresValidacion.length) {
            vm.equiposLista = consolidado
          } else vm.openErroresEncontrados()
        }
      }
    },
    getRowsFileExcel (file) {
      return new Promise((resolve, reject) => {
        const wb = new Excel.Workbook();
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;
          wb.xlsx.load(buffer).then(workbook => {
            resolve(workbook)
          })
        };
        reader.onerror = error => reject(error);
      });
    },
    adjuntarFileExcel () {
      var vm = this
      vm.renderInputFile = false
      vm.$nextTick(() => {
        vm.renderInputFile = true
      })
      var fileElement = document.getElementById('fileElement');
      fileElement.click()
    },
    fetchDescargarPlantilla () {
      var vm              = this
      var url = '/ticket/plantilla'
      var obj = {}
      console.log('obj: ', obj)
      apiGetExcel(vm, url, obj, function (data) {
        var a   = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);
        var blob    = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' })
        var url     = window.URL.createObjectURL(blob)
        a.href      = url;
        a.download  = 'plantilla_tickets_generar' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
      })
    },
    openModalValidarDatos () {
      var vm = this
      var alguno = vm.equiposLista.some(e => e.sigueEnGarantia)
      if (alguno) vm.isUploadModal = true
      vm.isModalConfirmacion = true
    },
    openErroresEncontrados () {
      var vm = this
      vm.isModalErroresEncontrados = true
    },
    clsoeErroresEncontrados () {
      var vm = this
      vm.erroresValidacion = []
      vm.isModalErroresEncontrados = false
    },
    fetchGuardarTicket (ticket, callback) {
      var vm = this
      console.log('ticket', ticket)
      var obj = {
        ticket     : ticket,
        isPlantilla: 1
      }

      apiPost(vm, '/ticket/registrar', obj, function (data) {
        callback(null, data)
      }, function (error) {
        callback(error)
      })
    },
    fetchInsertarActividad (adjunto, numeroTicket, callback) {
      var vm = this
      var obj = {
        numero       : numeroTicket,
        tipo         : 'adjunto',
        contenido    : adjunto.ruta,
        nombreAdjunto: adjunto.archivo,
        tipoAdjunto  : adjunto.mimetype,
        noEnviarEmail: 1
      }

      apiPost(vm, '/ticket/registrar/actividad', obj, data => {
        callback && callback(null)
      }, error => {
        callback && callback(error)
      })
    },
    uploadFile (file, callback) {
      var vm = this
      var fd = new FormData()
      var apiUploadRoute = process.env.API_UPLOAD_ROUTE
      var url = `${apiUploadRoute}/upload`
      fd.append('file', file)
      var params = {
        carpeta: 'actividades',
        usuario: localStorage.getItem('usuario')
      }

      apiUploadWithParams(vm, url, fd, params,  res => {
        callback(null, res)
      }, err => {
        callback(err)
      })
    },
    guardarTicketRecursivo (index, datosAdjunto, callback) {
      var vm = this
      vm.fetchGuardarTicket(vm.equiposLista[index], (err, response) => {
        if (err) callback(err)
        else {
          vm.equiposLista[index].status = 1
          vm.equiposLista[index].numero = response.numero
          vm.fetchInsertarActividad(datosAdjunto, response.numero, err => {
            if (err) callback(err)
            else {
              index++
              if (index === vm.equiposLista.length) callback(null)
              else vm.guardarTicketRecursivo(index, datosAdjunto, callback)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.display-none
  display: none
</style>



// WEBPACK FOOTER //
// View_creacion_ticket_multiple.vue?182568ec